import { useEffect, useRef, useState } from 'react';
import { launchConfetti, throwBall } from '../easterEggs';
import './HistoireEggs.css';

const cardOf = (event) => event.currentTarget.closest('.timeline-card');

// « Funfact » : 1 clic lance le ballon de la balle au prisonnier.
export function FunfactTag({ children }) {
  return (
    <span className="etape-tag egg-clickable" onClick={(event) => throwBall(cardOf(event))}>
      {children}
    </span>
  );
}

// « KO » : 1 clic lance le ballon de la balle au prisonnier.
export function KoWord() {
  return (
    <span className="egg-word" onClick={(event) => throwBall(cardOf(event))}>
      KO
    </span>
  );
}

// 💍 : pluie de cœurs.
export function Bague() {
  return (
    <span
      className="egg-word egg-bague"
      onClick={() => launchConfetti({ emojis: ['❤️', '💕', '💍', '✨', '🧡'], count: 60 })}
    >
      💍
    </span>
  );
}

// Position du « oui » sur la mini-carte (0-100 en largeur, 0-160 en hauteur).
const LIEU_FIANCAILLES = { x: 40, y: 96 };

// Contour simplifié de la Corse.
const CORSE_PATH =
  'M62 5 L66 15 L64 30 L66 40 L68 60 L70 80 L69 100 L66 120 L64 135 L55 155 L48 152 L44 140 ' +
  'L38 130 L30 122 L34 115 L24 108 L28 100 L18 92 L24 85 L16 76 L20 68 L12 60 L18 52 L22 42 ' +
  'L32 38 L40 35 L48 34 L52 38 L56 28 L56 15 Z';

// « Corse » : un clic ouvre une mini-carte.
export function CorseWord() {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) {
      return undefined;
    }
    const close = (event) => {
      if (!ref.current?.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  return (
    <span className="egg-corse" ref={ref}>
      <span className="egg-word" onClick={() => setOpen((prev) => !prev)}>
        Corse
      </span>
      {open && (
        <span className="egg-corse-popover" role="dialog" aria-label="Carte de la Corse">
          <svg viewBox="0 0 100 160" className="egg-corse-map">
            <path d={CORSE_PATH} />
            <circle
              className="egg-corse-pulse"
              cx={LIEU_FIANCAILLES.x}
              cy={LIEU_FIANCAILLES.y}
              r="5"
            />
            <circle className="egg-corse-point" cx={LIEU_FIANCAILLES.x} cy={LIEU_FIANCAILLES.y} r="4" />
          </svg>
          <span className="egg-corse-label">Ici, elle a dit oui 💍</span>
        </span>
      )}
    </span>
  );
}
